// input should be in cents and as an int (e.g. 320 => 3,20€)
export const convertToCurrency = (input) => {
  return ((input / 100).toFixed(2) + "€").replace('.', ',');
}